var _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNdeIconFormatsXls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#D1D2D3",
    strokeWidth: 1.2443,
    strokeMiterlimit: 10,
    points: "41.642,18.424 79.387,18.424  79.387,82.3 27.955,82.3 27.955,33.259  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.178,
    y: 22.371,
    fill: "#3BB34A",
    width: 54.129,
    height: 21.774
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#046938",
    points: "20.178,44.146 27.342,44.146 27.342,51.255  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.103,26.852h3.275l-3.798,5.872l4.113,6.305h-3.311l-2.596-4.006l-2.578,4.006h-3.275l4.094-6.236 l-3.814-5.94h3.257l2.317,3.607L32.103,26.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M37.364,39.028V26.852h2.718v9.755h5.191v2.422H37.364z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M50.107,29.281c-0.26,0.216-0.392,0.499-0.392,0.853c0,0.355,0.159,0.638,0.479,0.847 c0.319,0.209,1.058,0.456,2.211,0.739c1.157,0.287,2.055,0.711,2.693,1.279c0.639,0.57,0.957,1.4,0.957,2.494 c0,1.091-0.408,1.977-1.227,2.655c-0.819,0.679-1.897,1.021-3.232,1.021c-1.928,0-3.665-0.715-5.209-2.145l1.62-1.984 c1.312,1.148,2.527,1.725,3.641,1.725c0.5,0,0.891-0.107,1.175-0.322c0.286-0.215,0.429-0.506,0.429-0.871 c0-0.367-0.15-0.656-0.453-0.873c-0.304-0.213-0.901-0.432-1.796-0.652c-1.416-0.336-2.453-0.775-3.108-1.316 c-0.657-0.539-0.984-1.388-0.984-2.541c0-1.157,0.416-2.049,1.245-2.676c0.831-0.627,1.867-0.94,3.11-0.94 c0.812,0,1.627,0.14,2.438,0.418c0.814,0.279,1.521,0.673,2.127,1.188l-1.378,1.983c-1.055-0.802-2.148-1.202-3.273-1.202 C50.726,28.959,50.369,29.067,50.107,29.281z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.933,
    y: 50.362,
    fill: "#D1D2D3",
    width: 39.819,
    height: 27.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.765,
    y: 51.572,
    fill: "#FFFFFF",
    width: 10.456,
    height: 6.997
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.765,
    y: 60.388,
    fill: "#FFFFFF",
    width: 10.456,
    height: 6.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.765,
    y: 69.204,
    fill: "#FFFFFF",
    width: 10.456,
    height: 6.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.614,
    y: 51.572,
    fill: "#FFFFFF",
    width: 10.454,
    height: 6.997
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.614,
    y: 60.388,
    fill: "#FFFFFF",
    width: 10.454,
    height: 6.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.614,
    y: 69.204,
    fill: "#FFFFFF",
    width: 10.454,
    height: 6.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.464,
    y: 51.572,
    fill: "#FFFFFF",
    width: 10.454,
    height: 6.997
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.464,
    y: 60.388,
    fill: "#FFFFFF",
    width: 10.454,
    height: 6.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.464,
    y: 69.204,
    fill: "#FFFFFF",
    width: 10.454,
    height: 6.998
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.575,
    y: 65.936,
    fill: "#3BB34A",
    width: 3.889,
    height: 11.511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.323,
    y: 68.918,
    fill: "#3BB34A",
    width: 3.889,
    height: 8.528
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.071,
    y: 60.388,
    fill: "#3BB34A",
    width: 3.889,
    height: 17.059
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdeIconFormatsXls);
export default __webpack_public_path__ + "static/media/NDE_icon_formats_xls.4ea55a5c.svg";
export { ForwardRef as ReactComponent };